import React from "react";

/**
 * @component ProjectTemplateIcon
 * @description
 *
 * The React Icon component is a visual element that displays an icon to represent a concept, object, or action.
 * The Icon component is
 * customizable, allowing for variations in size, color, and style to fit the needs of the application.
 *
 *
 * @example
 * return (
 *   <ProjectTemplateIcon className="mr-2" />
 * )
 *
 * @see
 * https://system.activecollab.com/?path=/story/foundation-icons-icons--icons
 * @see
 * https://design.activecollab.com/docs/foundations/icons
 */
const ProjectTemplateIcon = React.forwardRef(
  (props: React.SVGProps<SVGSVGElement>, svgRef?: React.Ref<SVGSVGElement>) => (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      data-testid="ProjectTemplateIcon"
      fill="var(--color-theme-600)"
      focusable={false}
      ref={svgRef}
      {...props}
    >
      <path
        d="M20 4a2 2 0 012 2v14a2 2 0 01-2 2H6a2 2 0 01-2-2v-8h2v8h14V6h-8V4h8zm-8.464 6.121l2.535 2.536L16 10.75V16h-5.249l1.906-1.929-2.536-2.535 1.415-1.415zM8 1a2 2 0 012 2v5a2 2 0 01-2 2H3a2 2 0 01-2-2V3a2 2 0 012-2h5zm0 2H3v5h5V3z"
        fillRule="evenodd"
      />
    </svg>
  )
);
ProjectTemplateIcon.displayName = "ProjectTemplateIcon";
export default ProjectTemplateIcon;
